import { v4 as uuidv4 } from 'uuid';

export type GUID = string & { isGuid: true };

export const createGuid = () => uuidv4() as GUID;
